// extracted by mini-css-extract-plugin
export default {"select":"AntdSelect_select__ezH6S","popup":"AntdSelect_popup__HEQtf"};